import { MapPin, Play } from "lucide-react";
import { useState } from "react";
import { useT } from "@/lib/i18n";

export function OfficeMap() {
  const { tk } = useT();
  const [loaded, setLoaded] = useState(false);
  const mapsUrl =
    "https://www.google.com/maps/search/?api=1&query=Regus+Calle+Almutamid+6+Edificio+Vega+1+41900+Camas+Sevilla+Spain";
  const embedSrc =
    "https://www.google.com/maps?q=Calle+Almutamid+6,+Edificio+Vega+1,+41900+Camas,+Sevilla&hl=es&z=16&output=embed";

  return (
    <section className="border-t border-gold/15">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center mb-10">
          <span className="text-xs tracking-[0.4em] uppercase text-gold">
            {tk("office.2ca5a6", "Cómo llegar")}
          </span>
          <h2 className="font-serif text-3xl md:text-4xl mt-4">
            {tk("office.visit.a", "Visite ")}
            <em className="not-italic gold-gradient">
              {tk("office.visit.b", "nuestra sede central")}
            </em>
          </h2>
          <p className="mt-4 text-sm text-muted-foreground inline-flex items-center gap-2 justify-center">
            <MapPin size={14} className="text-gold" />
            {tk(
              "office.hq.address",
              "Calle Almutamid 6, Edificio Vega 1, 41900 Camas, Sevilla",
            )}
          </p>
        </div>
        <div className="rounded-2xl overflow-hidden border border-gold/20 bg-card/30 relative">
          {loaded ? (
            <iframe
              title="RR Lex Juristas — Sede central, Camas (Sevilla)"
              src={embedSrc}
              width="100%"
              height="450"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          ) : (
            <button
              type="button"
              onClick={() => setLoaded(true)}
              aria-label={tk("office.loadMap", "Cargar mapa interactivo")}
              className="group relative w-full h-[450px] flex flex-col items-center justify-center gap-4 bg-gradient-to-br from-card/60 to-card/20 hover:from-card/80 hover:to-card/30 transition-colors"
            >
              <div className="h-16 w-16 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center group-hover:bg-gold/25 transition-colors">
                <Play size={24} className="text-gold ml-1" />
              </div>
              <div className="text-sm font-medium text-foreground">
                {tk("office.loadMap", "Cargar mapa interactivo")}
              </div>
              <div className="text-xs text-muted-foreground max-w-xs text-center px-4">
                {tk(
                  "office.loadMap.note",
                  "Al cargar el mapa aceptas las cookies de Google Maps.",
                )}
              </div>
            </button>
          )}
        </div>
        <div className="mt-6 text-center">
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-gold border-b border-gold/40 pb-1 hover:border-gold"
          >
            {tk("office.7be061", "Abrir en Google Maps")}
          </a>
        </div>
      </div>
    </section>
  );
}
